import { OrgStructure } from "@teamprevent/common/orgStructure/models";

import { Location } from "redux-little-router";

export interface OrgStructureState {
    readonly orgStructures: OrgStructure[];
    readonly orgStructure?: OrgStructure;
}

export type SelectorState = OrgStructureState & { router: Location };

export const orgStructuresSelector = (state: SelectorState) => {
    const customerId = state?.router?.params?.customerId;
    let orgStructures = state.orgStructures;

    if (customerId) {
        orgStructures = orgStructures.filter(p => p.customerId === customerId);
    }

    return orgStructures;
};
